import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a778bf88295d500147a7e82_1787311767166_4cae310c/brainbasket/src/app/sign-up-login-screen/components/AuthScreen.tsx");
